import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-dqyla_icon",
  "use": "icon-dqyla_icon-usage",
  "viewBox": "0 0 34 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 34 32\" id=\"icon-dqyla_icon\">\n<title>dqyla_icon</title>\n<path d=\"M16.851 2.693l-8.084 8.084 11.314 11.314 8.041-8.041-11.27-11.357zM16.843 5.932l8.050 8.112-4.815 4.815-8.081-8.081 4.845-4.846z\" />\n<path d=\"M15.861 16.776l-6.465 6.465-1.616-1.616 6.465-6.465z\" />\n<path d=\"M29.753 25.939v2.286h-13.714v-2.286z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol